export default __webpack_public_path__ + "static/media/shiba6.ef63ef99.gif";